import React from 'react';
import { FaTaxi, FaMoneyBill, FaClock, FaCar, FaUserTie, FaMapMarkedAlt } from "react-icons/fa";
import { Helmet } from "react-helmet";


const WhyChooseUs = () => {
  const features = [
    {
      title: 'Reliable Taxi Service in Jaipur & Across India',
      description:
        'Looking for a taxi service near me? The Best Cab offers the most reliable cab service in Jaipur and provides seamless taxi booking services across India for local and outstation travel.',
      icon: <FaTaxi />
    },
    {
      title: 'Affordable Taxi Service with Transparent Pricing',
      description:
        'Enjoy a cheap taxi service with no hidden charges. Our affordable taxi service ensures budget-friendly rides, whether you need a local taxi service or an outstation cab for intercity travel.',
      icon: <FaMoneyBill />
    },
    {
      title: '24/7 Taxi Service – Always Available for You',
      description:
        'Need a 24/7 taxi service? Whether it’s early morning airport transfers, late-night pickups, or a day-long city tour, we ensure round-the-clock service for a stress-free journey.',
      icon: <FaClock />
    },
    {
      title: 'Wide Range of Cabs for Every Travel Need',
      description:
        'We offer a luxury taxi service, airport taxis, and tempo travelers. Whether you need a Jaipur to Delhi taxi, an outstation cab for a Rajasthan tour, or a one-way drop anywhere in India, we’ve got you covered!',
      icon: <FaCar />
    },
    {
      title: 'Professional Drivers & Hassle-Free Cab Booking Online',
      description:
        'Our trained drivers ensure a safe and reliable taxi service, and our easy cab booking online system allows you to book your ride instantly for a smooth travel experience.',
      icon: <FaUserTie />
    },
    {
      title: 'Custom Tour Packages for Rajasthan & Beyond',
      description:
        'Explore India with our customized tour packages! Whether it’s a sightseeing tour in Jaipur, a Rajasthan desert safari, or a long road trip across India, we create travel experiences tailored to your needs.',
      icon: <FaMapMarkedAlt />
    }

  ];

  return (
    <>
    
     <Helmet>
            <title>The Best Cab Jaipur – Affordable Taxi, One Way & Outstation Services</title>
            <meta
              name="description"
              content="Book reliable and affordable cab services in Jaipur for one-way, round trips, and outstation travel. Explore Rajasthan’s top destinations with our trusted taxi service and tour packages."
            />
            <meta
              name="keywords"
              content="Jaipur cab service, one way taxi, round trip taxi, outstation travel, affordable taxi, Rajasthan tours, taxi booking Jaipur"
            />
            <meta name="author" content="The Best Cab Jaipur" />
          </Helmet>
    <section className="bg-gradient-to-b from-white to-gray-100 py-16">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-extrabold text-center text-gray-900 mb-6">
          Why Choose <span className="text-pink-500">The Best Cab?</span>
        </h2>
        <p className="text-center text-lg text-gray-700 mb-10 max-w-2xl mx-auto">
          The Best Cab by Bharat Tours & Travels – Your trusted travel partner in Jaipur and across India for affordable, reliable, and comfortable rides!
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white shadow-xl rounded-2xl p-6 transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
            >
              <div className="flex items-center space-x-4">
                <div className="bg-pink-500 text-white p-3 rounded-full">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900">{feature.title}</h3>
              </div>
              <p className="text-gray-600 mt-3">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
    </>
  );
};

export default WhyChooseUs; 